<template>
<!-- 司机-优享券 -->
    <div class="container">
        <div class="handle-box-search">
            <el-button @click="add_isShow = !add_isShow" type="primary">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="名称" prop="name" min-width="100"> </el-table-column>
            <el-table-column label="有效天数" prop="expiration" min-width="80"> </el-table-column>
            <el-table-column label="总数" prop="num" min-width="80"> </el-table-column>
            <el-table-column label="剩余数量" prop="surplus" min-width="80"> </el-table-column>
            <el-table-column label="已发放" prop="already" min-width="80"> </el-table-column>
            <el-table-column label="创建日期" prop="time.YmdHis" min-width="100"> </el-table-column>
           

            <el-table-column label="操作" width="240" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" trigger="click" @click="sendPriorityFuntion(scope.row)"> 发放 </el-button>
                    <el-button type="primary" trigger="click" @click="toDetails(scope.row)"> 详情 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <!-- 添加组件 -->
        <addPrioritySubmit :isShow="add_isShow" @onSubmit="priorityLists"></addPrioritySubmit>
        <!-- 发放组件 -->
        <sendPriority :isShow="edit_isShow" :data="priority_mode_code" @onSubmit="priorityLists"></sendPriority>
        <!-- 优享券使用详情 -->
        <priorityDetailsLists :isShow="detail_isShow" :data="priority_mode_code" @onSubmit="priorityLists"></priorityDetailsLists>
    </div>
</template>
<script>
var _this;
import addPrioritySubmit from './addPrioritySubmit.vue';
import sendPriority from './sendPriority.vue';
import priorityDetailsLists from './priorityDetailsLists.vue';

export default {
    components: {
        addPrioritySubmit,
        sendPriority,
        priorityDetailsLists
    },
    data() {
        return {
            edit_isShow: false,
            add_isShow: false,
            detail_isShow: false,
            priority_mode_code: '',
            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10
            },
            // 存放表格数据
            tableData: [],
            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchPriorityLists();
    },

    methods: {
        sendPriorityFuntion(val) {
            _this.edit_isShow = !_this.edit_isShow;
            _this.priority_mode_code = val.priority_mode_code; //子组件data值
        },
        toDetails(val) {
            _this.detail_isShow = !_this.detail_isShow;
            _this.priority_mode_code = val.priority_mode_code; //子组件data值
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.priorityLists();
        },
        searchPriorityLists() {
            _this.search_data.page = 1;
            _this.priorityLists();
        },
        priorityLists() {
            _this
                .$post('/priority/priorityLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>